import { createContext } from "react";
import { createDefaultContext } from "../../../helpers/createDefaultContext";

type Context = {
  onOpenChange?: (open: boolean) => void;
};

export const DialogContext = createContext<Context>(createDefaultContext());
